/* eslint-disable no-useless-rename */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useMemo, useRef, useState} from 'react'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'

//components
// import WSButton from '_metronic/helpers/components/WSButton/WSButton'

//conatants

//css
import './QuickMessage.scss'
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

import {useLocation} from 'react-router-dom'

import Select, {MenuListProps, components} from 'react-select'
///////////////working/////////////

import {Form, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import React from 'react'
import CreatableSelect from 'react-select/creatable'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import MessageBoxV2 from '../../../../Components/MessageBoxV2'
import moment from 'moment-timezone'

export const initialData = {
  ruleName: '',
}

const TriggerActionPopup = ({
  valid,
  setValid,
  show,
  handleClose,
  contacts,
  CustomReplyReport,
  setCustomReplyReport = () => {},
}: any) => {
  const dispatch = useDispatch()
  const param: any = useLocation()

  ////////////////////////////////////////////////////////////////USE SELECTOR//////////////////////
  const quickmsg = useSelector((state: any) => state?.quickMsg?.QuickMsg)
  const isAdmin = localStorage.getItem('isAdmin')

  /////////////////////////////////USE STATE/////////////////
  const [templateNameModel, setTemplateNameModel] = useState(false)
  const [quickSms, setQuickSms] = useState(true)
  const [success, setSuccess] = useState(false)
  const [preview, setPreview] = useState(false)

  const [sendData, setSendData] = useState<any>(initialData)

  const [error, setError] = useState<any>({})

  const [options, setOptions] = useState({
    webLink: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    customLanding: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    optOut: [
      {value: "Reply 'STOP' to opt-out ", label: 'Reply Stop'},
      {value: 'STOP:{stoptxt.cc/}', label: 'custom survey'},
    ],
  })

  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={async () => {
          handleClose()
        }}
        className={`quickMessageModal ${show ? 'right' : 'left'} `}
        dialogClassName={`modal-dialog-centered mw-450px w-100 nopreviweQuickMessage`}
      >
        <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>
          <div
            className='card-header pe-5 quick-message-header'
            id='kt_drawer_chat_messenger_header'
          >
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <a
                  href='#'
                  className='fs-4 fw-bolder text-gray-900 text-hover-primary m-0 lh-1 d-flex align-items-center gap-2 '
                  style={{textDecoration: 'none', margin: '0px !important'}}
                >
                  <img src='/media/svg/automation/home.svg' alt='icon' />
                  Trigger
                </a>
              </div>
            </div>

            <div className='card-toolbar'>
              <div
                className='btn btn-sm btn-icon btn-active-light-primary'
                id='kt_drawer_chat_close'
                onClick={handleClose}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </div>
            </div>
          </div>

          <form className='form quick-message-form' noValidate>
            <div className='card-body '>
              <div className='d-flex'>
                <div className='d-flex'>
                  <div className='QuickMsgLeft'>
                    <div className='trigger-errror-conatiner'>
                      <div className='left'>
                        <img src='/media/svg/automation/security.svg' alt='icon' />
                      </div>
                      <div className='right'>
                        <div className='title'>You can't change this</div>
                        <div className='desc'>
                          Our experts have a proven method that can get you more reviews, we got
                          this!
                        </div>
                        <div className='learn-more'>
                          Learn more <i className='bi bi-chevron-right'></i>
                        </div>
                      </div>
                    </div>
                    <div className='mt-6 w-400px'>
                      <label className='form-label'>Trigger action</label>
                      <Select
                        options={[
                          {value: 'Contact enters segment', label: 'Contact enters segment'},
                        ]}
                      />
                    </div>
                    <div className='mt-8 w-400px'>
                      <label className='form-label'>Segment</label>
                      <Select options={[{value: 'Segment', label: 'Segment'}]} className='w-100' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default TriggerActionPopup
